var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v("Versione")]),_vm._v(" "+_vm._s(_vm.version)+"\n    ")]),_vm._v(" "),_c('strong',[_vm._v("Copyright © "+_vm._s(new Date().getFullYear())+" "),_c('a',{attrs:{"href":"http://www.cinescatti.it"}},[_vm._v("Cinescatti")]),_vm._v(".")]),_vm._v("\n    Tutti i diritti riservati.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c80056e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Foot.vue
// module id = ur+n
// module chunks = 1